import { httpsCallable } from 'firebase/functions';
import { functions } from './firebase';
import type { Role } from '../types';

export async function createManagedUser(input: { email: string; password: string; name: string; role: Role; organizationId: string; departmentId: string }): Promise<string> {
  const result = await httpsCallable<typeof input, { uid: string }>(functions, 'createUser')(input);
  return result.data.uid;
}

export async function manageManagedUser(input: { uid: string; role?: Role; disabled?: boolean }): Promise<void> {
  await httpsCallable<typeof input, { ok: boolean }>(functions, 'manageUser')(input);
}

export type TaskManagementAction =
  | { action: 'remind'; taskId: string }
  | { action: 'reschedule'; taskId: string; dueAtMillis: number; reason: string }
  | { action: 'reassign'; taskId: string; assigneeIds: string[]; reason: string }
  | { action: 'cancel'; taskId: string; reason: string };

export async function manageTaskAction(input: TaskManagementAction): Promise<void> {
  await httpsCallable<TaskManagementAction, { ok: boolean }>(functions, 'manageTaskAction')(input);
}

export async function generateManagedPasswordReset(email: string): Promise<string> {
  const result = await httpsCallable<{ email: string }, { link: string }>(functions, 'generatePasswordReset')({ email });
  return result.data.link;
}
